import React, { useMemo } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { UserRoleFormValues } from '../../types';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useRoleQuery } from '~/App/query/role';
import api from '~/App/User/api';

const rules = [{ required: true, message: 'Wajib diisi' }];

const UserField = () => {
  const { data } = useSuspenseQuery({
    queryKey: ['fetchUsers'],
    queryFn: () => {
      return api.getUsers().then(({ users }) => users);
    },
  });

  const options = useMemo(() => {
    return data.map(({ userId, username }) => ({
      value: userId,
      label: username,
    }));
  }, [data]);

  return (
    <Form.Item name="userId" label="User" rules={rules}>
      <Select
        showSearch
        filterOption={(input, { value, label }: any) => {
          return (
            (value ?? '').toLowerCase().includes(input.toLowerCase()) ||
            (label ?? '').toLowerCase().includes(input.toLowerCase())
          );
        }}
        placeholder="Select user"
        options={options}
      />
    </Form.Item>
  );
};

const RoleField = () => {
  const roles = useRoleQuery();

  const options = useMemo(() => {
    return roles.map(({ restaurantRoleId, roleName }) => ({
      value: restaurantRoleId,
      label: roleName,
    }));
  }, [roles]);

  return (
    <Form.Item name="roleIds" label="Role(s)" rules={rules}>
      <Select
        showSearch
        mode="multiple"
        filterOption={(input, { value, label }: any) => {
          return (
            (value ?? '').toLowerCase().includes(input.toLowerCase()) ||
            (label ?? '').toLowerCase().includes(input.toLowerCase())
          );
        }}
        placeholder="Select roles"
        options={options}
      />
    </Form.Item>
  );
};

const UserRoleForm = ({
  initialValues,
  loading,
  onSubmit,
}: {
  initialValues?: UserRoleFormValues;
  loading: boolean;
  onSubmit: (values: UserRoleFormValues) => void;
}) => {
  return (
    <Form<UserRoleFormValues>
      name="userRoleForm"
      layout="vertical"
      onFinish={onSubmit}
      initialValues={initialValues}
    >
      <UserField />
      <RoleField />
      <Button type="primary" htmlType="submit" loading={loading}>
        Submit
      </Button>
    </Form>
  );
};

export default UserRoleForm;
